import 'react-toastify/dist/ReactToastify.css';

/**
 * アプリケーション
 */
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BrowserRouter as Router, Redirect, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import styles from './App.module.scss';
import AuthProvider from './components/auth-provider';
import AuthRoute from './components/auth-route';
import Header from './components/header';

import Menu from './components/menu';
import Eqlist from './components/eqlist';

import { homepage } from '../package.json';
import Devicelist from './components/devicelist';
import EqMaintMenu from './components/eq-maint-menu';
import PartsList from './components/parts-list';
import DeviceDetailPage from './components/device-detail';
import PartsDetailPage from './components/parts-detail';
import DeviceMaintMenu from './components/device-maint-menu';
import DeviceitemList from './components/device-maint-item';
import DeviceMaintlist from './components/device-maint-list';
import DeviceMaintDetailPage from './components/device-maint-detail';
import EqMaintlist from './components/eq-maint-list';
import EqMaintDetailPage from './components/eq-maint-detail';
import EqAchievelist from './components/eq-maint-achieve';
import EqTroubleList from './components/eq-trouble-list';
import EqTroubleDetailPage from './components/eq-trouble-detail';
import EqCsetList from './components/eq-cset-list';
import EqCsetDetailPage from './components/eq-cset-detail';
import DeviceTroublelist from './components/device-troule-list';
import DeviceTroubleDetailPage from './components/device-trouble-detail';

// ルーティングのパス名
export const routeName: Record<string, string> = {
  id: '/:id', // IDを渡す用
  eqId: '/:eqid', // 設備情報取得用
  mstId: '/:mstid', // 機器ID

  login: '/login', // ログイン画面
  menu: '/menu', // メニュー画面
  eqList: '/eq-list', // 設備一覧画面
  deviceList: '/device-list', // 設備機器一覧画面
  deviceDetail: '/device-detail', // 機器詳細画面
  partsList: '/parts-list', // 機器部品一覧画面
  partsDetail: '/parts-detail', // 部品詳細画面

  deviceMaintMenu: '/device-maint-menu', // 機器点検等メニュー画面
  deviceMaintItem: '/device-maint-item', // 機器点検項目一覧画面
  deviceMaintList: '/device-maint-list', // 機器点検履歴画面
  deviceMaintDetail: '/device-maint-detail', // 機器点検履歴詳細画面
  deviceTroubleList: '/device-trouble-list', // 機器故障修理履歴画面
  deviceTroubleDetail: '/device-trouble-detail', // 機器故障修理履歴詳細画面

  eqMaintMenu: '/eq-maint-menu', // 設備点検等メニュー画面
  eqMaintList: '/eq-maint-list', // 設備点検履歴画面
  eqMaintDetail: '/eq-maint-detail', // 設備点検履歴詳細画面
  eqMaintAchieve: '/eq-maint-achieve', // 設備点検実績一覧画面
  eqTroubleList: '/eq-trouble-list', // 設備故障修理履歴画面
  eqTroubleDetail: '/eq-trouble-detail', // 設備故障修理履歴詳細画面
  eqCsetList: '/eq-cset-list', // 設備改造移設撤去履歴画面
  eqCsetDetail: '/eq-cset-detail', // 設備改造移設撤去履歴詳細画面
};

/**
 * ルーティング設定をここで行う
 */
function App(): React.ReactElement {
  return (
    <div className={`${styles.App}`}>
      <Router basename={homepage}>
        <AuthProvider>
          <Header />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnFocusLoss
            draggable
            pauseOnHover={false}
          />
          <Container fluid className={`flex-full ${styles.TopContainer}`}>
            <Row className="w-100 h-100">
              <Col className="col-12">
                <Switch>
                  {/* ログイン画面 */}
                  <AuthRoute
                    path={routeName.login}
                    render={() => <Redirect to={routeName.menu} />}
                  />
                  {/* メニュー画面 */}
                  <AuthRoute path={routeName.menu} render={() => <Menu />} />
                  {/* 設備一覧画面 */}
                  <AuthRoute
                    path={routeName.eqList}
                    render={() => <Eqlist />}
                  />
                  {/* 設備機器一覧画面 */}
                  <AuthRoute
                    path={routeName.deviceList + routeName.id}
                    render={() => <Devicelist />}
                  />
                  {/* 機器詳細画面 */}
                  <AuthRoute
                    path={
                      routeName.deviceDetail + routeName.eqId + routeName.id
                    }
                    render={() => <DeviceDetailPage />}
                  />
                  {/* 機器部品一覧画面 */}
                  <AuthRoute
                    path={routeName.partsList + routeName.eqId + routeName.id}
                    render={() => <PartsList />}
                  />
                  {/* 部品詳細画面 */}
                  <AuthRoute
                    path={
                      routeName.partsDetail +
                      routeName.eqId +
                      routeName.mstId +
                      routeName.id
                    }
                    render={() => <PartsDetailPage />}
                  />
                  {/* 機器点検等メニュー画面 */}
                  <AuthRoute
                    path={
                      routeName.deviceMaintMenu + routeName.eqId + routeName.id
                    }
                    render={() => <DeviceMaintMenu />}
                  />
                  {/* 機器点検項目一覧画面 */}
                  <AuthRoute
                    path={
                      routeName.deviceMaintItem + routeName.eqId + routeName.id
                    }
                    render={() => <DeviceitemList />}
                  />
                  {/* 機器点検履歴画面 */}
                  <AuthRoute
                    path={
                      routeName.deviceMaintList + routeName.eqId + routeName.id
                    }
                    render={() => <DeviceMaintlist />}
                  />
                  {/* 機器点検履歴詳細画面 */}
                  <AuthRoute
                    path={
                      routeName.deviceMaintDetail +
                      routeName.eqId +
                      routeName.mstId +
                      routeName.id
                    }
                    render={() => <DeviceMaintDetailPage />}
                  />
                  {/* 機器故障修理履歴画面 */}
                  <AuthRoute
                    path={
                      routeName.deviceTroubleList +
                      routeName.eqId +
                      routeName.id
                    }
                    render={() => <DeviceTroublelist />}
                  />
                  {/* 機器故障修理履歴詳細画面 */}
                  <AuthRoute
                    path={
                      routeName.deviceTroubleDetail +
                      routeName.eqId +
                      routeName.mstId +
                      routeName.id
                    }
                    render={() => <DeviceTroubleDetailPage />}
                  />
                  {/* 設備点検メニュー画面 */}
                  <AuthRoute
                    path={routeName.eqMaintMenu + routeName.id}
                    render={() => <EqMaintMenu />}
                  />
                  {/* 設備点検履歴画面 */}
                  <AuthRoute
                    path={routeName.eqMaintList + routeName.id}
                    render={() => <EqMaintlist />}
                  />
                  {/* 設備点検履歴詳細画面 */}
                  <AuthRoute
                    path={
                      routeName.eqMaintDetail + routeName.eqId + routeName.id
                    }
                    render={() => <EqMaintDetailPage />}
                  />
                  {/* 設備点検実績一覧画面 */}
                  <AuthRoute
                    path={routeName.eqMaintAchieve + routeName.id}
                    render={() => <EqAchievelist />}
                  />
                  {/* 設備故障修理履歴画面 */}
                  <AuthRoute
                    path={routeName.eqTroubleList + routeName.id}
                    render={() => <EqTroubleList />}
                  />
                  {/* 設備故障修理履歴詳細画面 */}
                  <AuthRoute
                    path={
                      routeName.eqTroubleDetail + routeName.eqId + routeName.id
                    }
                    render={() => <EqTroubleDetailPage />}
                  />
                  {/* 設備改造移設撤去履歴画面 */}
                  <AuthRoute
                    path={routeName.eqCsetList + routeName.id}
                    render={() => <EqCsetList />}
                  />
                  {/* 設備改造移設撤去履歴詳細画面 */}
                  <AuthRoute
                    path={
                      routeName.eqCsetDetail + routeName.eqId + routeName.id
                    }
                    render={() => <EqCsetDetailPage />}
                  />
                  <Redirect to="/login" />
                </Switch>
              </Col>
            </Row>
          </Container>
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;
